module.exports = {
    port: 3002,
    dbname: 'bedrina_prod',
    baseUrl: 'https://bedrinaprojekt.hr',
    mailConfig: {
        host: 'srebro.avalon.hr',
        secure: true,
        port: 465,
        transportMethod: 'SMTP',
        auth: {
            user: 'info@findinapp.com',
            pass: 'siromastvo1!'
        }
    }
}




// WEBPACK FOOTER //
// ./server/config/server.js